import { put, call, all, putResolve } from 'redux-saga/effects'
import { initialize } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'
import createAction from 'loankeeper-common/helpers/createAction'
import moment from 'moment'
import mapValues from 'lodash/mapValues'
import { CustomFieldsGroup } from '@lk/api'

import { getClientReqFields, getClientSelects } from '../../../store/client'

import {
  loadCustomFields,
  customFieldsAttributesToString,
  LoadCustomFieldsAttributes,
} from '../../../store/customFields'
import { ClientAttributes, loadClientDynamicFields, loadEditDetails } from '../../../store/client'
import { actionTypes, countryToCityTypes, FORM_NAME } from '../constants'
import { loadCitiesByCountryId } from 'src/store/lookups'

const normalizedRequiredFields = (requiredFields) =>
  requiredFields.reduce((result, value) => {
    if (value.FName === 'CardNumber') {
      value.Active = 1
    }

    result[value.FName] = value

    return result
  }, {})

export default function* ({ payload: { clientType, groupid = 1, editting, ID, hash, countryID } }) {
  try {
    const subgroupid = clientType === 1 ? 11 : 13

    const requests = [
      //UPDATED API REQUEST client_reqfields_api
      putResolve<any>(
        getClientReqFields({
          typeid: clientType,
          groupid,
        }),
      ),

      // call(Client.getSelects),
      //UPDATED API REQUEST client_lookups_api
      putResolve<any>(getClientSelects()),
    ]

    const [requiredFieldsResponse, clientLookupsResponse] = yield all(requests)
    // const selects = clientLookupsResponse.Data
    const selects = clientLookupsResponse.payload
    let countryIDs

    const customFieldsAttributes = {
      groupId: CustomFieldsGroup.Client,
      subGroupId: subgroupid,
    }

    const customFieldsResult = yield putResolve<any>(
      loadCustomFields({
        cacheKey: customFieldsAttributesToString(customFieldsAttributes),
        ...customFieldsAttributes,
      } as LoadCustomFieldsAttributes),
    )

    if (editting) {
      const { payload: editDetails } = yield putResolve<any>(
        loadEditDetails({ clientId: ID, clientHash: hash } as ClientAttributes),
      )

      const { payload: dynamicFields } = yield putResolve<any>(
        loadClientDynamicFields({ clientId: ID, clientHash: hash } as ClientAttributes),
      )

      const DynFieldData = mapValues(dynamicFields, (value) => {
        return LKDate.isValidFormat(value)
          ? moment(value, 'YYYY-MM-DD HH:mm:ss', true).format('DD.MM.YYYY')
          : value.toString()
      })

      const formatedData = Object.keys(editDetails).reduce((accumulator, current) => {
        let currentValue = editDetails[current]

        if (['1900-01-01 00:00:00', '1899-12-30 00:00:00'].includes(currentValue)) {
          currentValue = ''
        } else if (LKDate.isValidFormat(currentValue)) {
          currentValue = LKDate.from(currentValue).toString()
        }

        if (current === 'IND_ProfessionID_') {
          current = 'IND_ProfessionID'
        }

        const result = {
          ...accumulator,
          [current]: currentValue,
        }

        if (['CardNumber', 'OtherIDNumber'].includes(current)) {
          result[`${current}Alt`] = currentValue
        }
        if (['CellPhone'].includes(current)) {
          result.OrgCellPhone = currentValue
          result.CellPhoneValidateCode = ''
        }

        if (['Country2ID', 'CountryBusID', 'CountryID'].includes(current)) {
          const cID = result[current]
          countryIDs = {
            ...countryIDs,
            [current]: cID,
          }
        }

        return result
      }, {} as Record<string, unknown>)

      yield put(
        initialize(FORM_NAME, {
          ...formatedData,
          ID,
          hash,
          action: 'edit',
          DynFieldData,
          CodeVerifyPass: 0,
        }),
      )
    }

    let cityList: Record<string, any[]>

    const {
      payload: { lookups: cities },
    } = yield putResolve<any>(loadCitiesByCountryId(countryID))

    if (countryIDs) {
      for (let [key, value] of Object.entries(countryIDs)) {
        const cityKey = `${countryToCityTypes[key]}List`

        if (value != countryID) {
          const {
            payload: { lookups: citiesByCountry },
          } = yield putResolve<any>(loadCitiesByCountryId(value.toString()))

          cityList = {
            ...cityList,
            [cityKey]: citiesByCountry,
          }
        } else {
          cityList = {
            ...cityList,
            [cityKey]: cities,
          }
        }
      }
    } else {
      cityList = {
        CityIDList: cities,
        City2IDList: cities,
        CityBusIDList: cities,
      }
    }

    yield put(
      createAction(actionTypes.FETCH_SUCCESS, {
        selects,
        fields: normalizedRequiredFields(requiredFieldsResponse.payload.ReqFields),
        dynamicFields: customFieldsResult.payload.data,
        cities,
        cityList,
      }),
    )
  } catch (error) {
    yield put(createAction(actionTypes.FETCH_FAILURE, { error }))
  }
}
